<template>
  <div>
    <div class="info--text text-uppercase my-3 mt-2">
      {{ generateMessage('requests.details.titles.dangerousSituations') }}
    </div>
    <div
      class="d-flex flex-wrap"
      v-if="property.dangerous_situations_instructions.length > 0"
    >
      <v-col cols="12">
        <v-data-table
          dense
          :loading="loading"
          hide-default-footer
          fixed-header
          height="155"
          disable-sort
          disable-pagination
          :items="property.dangerous_situations_instructions"
          :headers="listHeaders"
          class="secondarybackground striped-table clickable ma-2 caption"
        >
          <template v-slot:item.tech_answer_datetime="{ value }">
            {{ new Date(value).toLocaleString() }}
          </template>
        </v-data-table>
      </v-col>
    </div>
    <div class="d-flex flex-wrap caption" v-else>
      {{ generateMessage('requests.details.titles.noDangerousSituations') }}
    </div>
  </div>
</template>

<script>
import { generateMessage } from '@/utils/i18n';
import { createNamespacedHelpers } from 'vuex';

const { mapGetters } = createNamespacedHelpers('properties_360');

export default {
  name: 'PropertyDangerousSituations',
  computed: {
    ...mapGetters({ property: 'current', loading: 'isLoadingCurrent' }),
  },
  methods: {
    generateMessage,
  },
  data: () => ({
    listHeaders: [
      { text: 'Date', value: 'tech_answer_datetime' },
      { text: 'Niveau du risque', value: 'risk_level' },
      { text: 'Nature(s)', value: 'risk_nature' },
      { text: 'Consigne', value: 'instruction' },
      { text: 'Consigne de sécurité', value: 'security_instruction' },
    ].map((item) => {
      return { ...item, class: 'secondarybackground' };
    }),
  }),
};
</script>

<style scoped lang="scss">
@import '@/styles/table.scss';
</style>
